const HOTEL_ID_COOKIE_NAME = "hotel_id";
const HOTEL_ID_COOKIE_DOMAIN = ".chillnn.com";

/**
 * support.chillnn.com と hotel_id を共有するためのクロスサブドメイン cookie を書き込む。
 * domain=.chillnn.com のため chillnn.com のサブドメインでない環境（localhost等）では
 * ブラウザが cookie ごと破棄するが、その場合 getHotelIdCookie() が null を返すだけで安全。
 * Expires/Max-Age を付けないセッション cookie（ブラウザを閉じたら消える）。
 */
export function setHotelIdCookie(hotelId: string): void {
	if (typeof document === "undefined") return;

	const secure = location.protocol === "https:" ? "; Secure" : "";
	document.cookie = `${HOTEL_ID_COOKIE_NAME}=${encodeURIComponent(hotelId)}; domain=${HOTEL_ID_COOKIE_DOMAIN}; path=/; SameSite=Lax${secure}`;
}

/** document.cookie から hotel_id を読み取る。存在しない場合は null。 */
export function getHotelIdCookie(): string | null {
	if (typeof document === "undefined") return null;

	const match = document.cookie.match(/(?:^|; )hotel_id=([^;]*)/);
	return match ? decodeURIComponent(match[1]) : null;
}
